// Status configuration: colors, labels, ordering
export const STATUS_FLOW = [
  "Draft",
  "Submitted",
  "Material In Transit",
  "Material Received",
  "Pending Inspection",
  "Approved",
  "Partially Approved",
  "Rejected",
  "Credit Note Pending",
  "Credit Note Uploaded",
  "Closed",
];

export const STATUS_STYLE = {
  Draft: "bg-neutral-100 text-neutral-700 border-neutral-200",
  Submitted: "bg-blue-50 text-blue-700 border-blue-200",
  "Material In Transit": "bg-indigo-50 text-indigo-700 border-indigo-200",
  "Material Received": "bg-teal-50 text-teal-700 border-teal-200",
  "Pending Inspection": "bg-amber-50 text-amber-700 border-amber-200",
  Approved: "bg-green-50 text-green-700 border-green-200",
  "Partially Approved": "bg-lime-50 text-lime-700 border-lime-200",
  Rejected: "bg-red-50 text-red-700 border-red-200",
  "Credit Note Pending": "bg-cyan-50 text-cyan-700 border-cyan-200",
  "Credit Note Uploaded": "bg-emerald-50 text-emerald-700 border-emerald-200",
  Closed: "bg-stone-100 text-stone-700 border-stone-300",
};

export const ROLE_LABEL = {
  admin: "Administrator",
  customer: "Customer",
  inward: "Inward Team",
  quality: "Quality Team",
  accounts: "Accounts Team",
};

export const REASONS = [
  "Damaged in transit",
  "Quality defect",
  "Wrong specification",
  "Excess quantity",
  "Customer rejection",
  "Other",
];
